// extracted by mini-css-extract-plugin
export default {"label":"Label-module__label___1slSi","sm":"Label-module__sm___5JvCS","lg":"Label-module__lg___1IDQI","xs":"Label-module__xs___myECA","error":"Label-module__error___LnlxZ"};